import { create } from "zustand"
import { devtools } from "zustand/middleware"

export interface LoadingState {
  hasEnterHover: boolean
  hasClicked: boolean
  hasClickedAbout: boolean
  setHasEnterHover: (hasEnterHover: boolean) => void
  setHasClicked: (hasClicked: boolean) => void
}

export const useLoadingStore = create<LoadingState>()(
  devtools((set) => ({
    hasEnterHover: false,
    hasClicked: false,
    hasClickedAbout: false,
    setHasEnterHover: (hasEnterHover: boolean) => set({ hasEnterHover }),
    setHasClicked: (hasClicked: boolean) => set({ hasClicked }),
  })),
)
